import {createGate} from 'effector-react';

import {fetchDocumentAggregationCreate} from 'api/documents/aggregation';
import {rootDomain} from 'core/rootDomain';
import {AggregationFormData} from 'types';

const domain = rootDomain.createDomain('AggregationDomain');
export const AggregationGate = createGate('AggregationGate');

export const sendAggregationFx = domain.createEffect({
    name: 'sendAggregationFx',
    handler: fetchDocumentAggregationCreate,
});

export const step$ = domain.createStore<number>(0);
export const stepChanged = domain.createEvent<number>();

export const createAggregationDocument = domain.createEvent();

export const aggregationFormChanged = domain.createEvent<Partial<AggregationFormData>>();
export const aggregationForm$ = domain.createStore<AggregationFormData>({
    aggregationType: 'aggregation',
    aggregationNumber: null,
    storageLocationId: null,
    storageLocationName: '',
});
